module.exports = __webpack_public_path__ + "img/mp2.f79ed69b.png";